module.exports = __webpack_public_path__ + "static/bootstrap-button-toolbar-19a78cc71446c706efe89a71da2b9c80.png";